import PastFeedbackCard from './crm_ui/sidebar/layouts/card/PastFeedbackCard';
export default PastFeedbackCard;